'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itRenderingFn", function () {
  /**
   * Generator function for the table rendering fn.
   */
  return function renderingFnFactory(tableCtrl, renderer) {
    var getCurrentHeight = function getCurrentHeight() {
      return tableCtrl.ui.contentTable[0].clientHeight; // significantly faster than using jQuery
      // return tableCtrl.ui.contentTable.height();
    };

    /**
     * The main rendering method for infiniTable, standard and tree modes.
     *
     * Options :
     *      - index     : the index to start rendering at
     *      - initial   : true if it's the first rendering since datasource refresh
     *      - full      : if set to true, then it will print all the lines ( no scrolling ).
     *                    used for print for example
     */
    return function renderingFn(options) {
      // console.time("renderingFn");

      var displayedRows = renderer.getDisplayedRows(),
        oldRows = displayedRows.slice(0),
        actualLength = renderer.getActualLength(),
        dataSource = tableCtrl.getDataSource();

      // empty the currently displayed rows
      displayedRows.splice(0, displayedRows.length);

      // detaching old rows to empty the table
      for (var i = 0; i < oldRows.length; i++) {
        oldRows[i].detach();
      }

      // hyjacking when empty dataSource
      if (!dataSource || !actualLength) {
        return;
      }
      var fullMode = options.full /*|| true*/,
        index = fullMode ? 0 : options.index,
        initial = options.initial,
        rowContainer = tableCtrl.ui.contentBody,
        config = tableCtrl.getConfig(),
        firstIdx = fullMode ? 0 : index || 0,
        lastIdx,
        currentIdx = firstIdx,
        filled = false,
        availableHeight = tableCtrl.getAvailableBodyHeight(),
        nextRow;
      tableCtrl.ui.contentTable.css("height", "auto");
      if (firstIdx >= actualLength) {
        firstIdx = index = actualLength - 1;
      }

      // are we filling from the bottom ? aka is the last element of the table the active one ?
      var fromBottom = index > 0 && index === actualLength - 1;
      do {
        var row = renderer.getOrCreateRow(currentIdx);
        if (row !== undefined) {
          nextRow = row.appendTo(rowContainer).show();
          displayedRows.push(nextRow);
        } else {
          console.log('undefined row at ', currentIdx, tableCtrl);
        }
        if (!fullMode) {
          filled = getCurrentHeight() >= availableHeight;

          // initial draw -> we need to double check that column sizing is correct before assuming table is filled.
          if (initial && filled) {
            tableCtrl.refreshColumnsSizing();
            filled = getCurrentHeight() >= availableHeight;
          }
        }
        currentIdx++;
      } while (!filled && currentIdx < actualLength);
      lastIdx = currentIdx - 1;

      // not filled : we were at the end of the table. need to reverse fill when possible
      if (!filled && firstIdx > 0) {
        var previousRow;
        currentIdx = firstIdx - 1;
        do {
          previousRow = renderer.getOrCreateRow(currentIdx).prependTo(rowContainer).show();
          displayedRows.unshift(previousRow);
          filled = getCurrentHeight() >= availableHeight;
          currentIdx--;
        } while (!filled && currentIdx > -1);
        firstIdx = currentIdx + 1;
      }

      // if filled from bottom
      if (fromBottom) {
        var tableOffset = getCurrentHeight() - availableHeight;
        // si negatif, alors cela crée un décalge en haut, on ramène à 0 (à voir un jour avec PGA).
        if (tableOffset < 0) {
          tableOffset = 0;
        }
        tableCtrl.ui.contentTable.css({
          bottom: tableOffset + "px"
        });
      } else {
        tableCtrl.ui.contentTable.css({
          bottom: "0px"
        });
      }

      // // overflow : last row is only partially visible -> we remove it from the count for the pagination state
      var overflow = getCurrentHeight() > availableHeight;
      if (overflow) {
        if (fromBottom) {
          firstIdx += 1;
        } else {
          lastIdx -= 1;
        }
      }
      tableCtrl.context.pagination = {
        first: firstIdx,
        last: lastIdx,
        count: lastIdx - firstIdx + 1,
        total: actualLength,
        filled: filled,
        full: fullMode || firstIdx === 0 && lastIdx === actualLength - 1 && getCurrentHeight() <= availableHeight
      };

      // console.timeEnd("renderingFn");

      // console.log("rendered", firstIdx, lastIdx)

      // refresh scrollbar state
      tableCtrl.getScrollBar().refresh();
      tableCtrl.applyUsedHeight();
      tableCtrl.ui.contentTable.css("height", "100%");
      if (config.onScrollChange) {
        config.onScrollChange(tableCtrl.context.pagination, dataSource);
      }
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itRenderingFn.js
// module id = 2800
// module chunks = 13